// extracted by mini-css-extract-plugin
export default {"button":"ExportToExcel_button__L5KLE","table":"ExportToExcel_table__OkjR-"};